import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import CustomLuxonUtils from 'lib/CustomLuxonUtils'
import {
  MuiPickersUtilsProvider,
  DatePicker,
  KeyboardTimePicker,
} from '@material-ui/pickers'
import Grid from '@material-ui/core/Grid'
import InputAdornment from '@material-ui/core/InputAdornment'
import EventIcon from '@material-ui/icons/Event'
import { makeStyles } from '@material-ui/core/styles'
import TimeIcon from '@material-ui/icons/AccessTime'
import { roundDateTimeMinutes } from 'utils/dateUtils'

const useStyles = makeStyles(theme => ({
  pickerContainer: {
    marginTop: '16px',
    [theme.breakpoints.down('sm')]: {
      margin: '0',
      marginTop: '16px',
      width: '100%',
    },
  },
  adornedEnd: {
    paddingRight: '8px',
    '& button': {
      padding: 0,
    },
  },
}))

const RegistrationClose = () => {
  const { control, register, errors } = useFormContext()
  const classes = useStyles()

  const handleTimeChange = (event, onChange) => {
    const roundedMinutesTime = roundDateTimeMinutes(event)
    if (roundedMinutesTime) {
      onChange(roundedMinutesTime)
    }
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      style={{ marginTop: '40px' }}
    >
      <Typography variant="subtitle1" gutterBottom>
        Registration close date
      </Typography>
      <Typography variant="body2" gutterBottom>
        Select the date and time this event registration will close.
      </Typography>
      <Box style={{ maxWidth: '450px' }}>
        <MuiPickersUtilsProvider utils={CustomLuxonUtils}>
          <Grid container spacing={4} className={classes.pickerContainer}>
            <Grid item xs={5}>
              <Box>
                <Controller
                  control={control}
                  name="registrationCloseDate"
                  render={props => (
                    <DatePicker
                      label="Close date"
                      id="registration-close-date"
                      name="registrationCloseDate"
                      innerRef={register}
                      value={props.value}
                      error={!!errors.registrationCloseDate}
                      helperText={
                        errors.registrationCloseDate
                          ? 'Please select a start date'
                          : null
                      }
                      format="MMM dd, yyyy"
                      onChange={e => props.onChange(e)}
                      disablePast
                      InputProps={{
                        endAdornment: (
                          <InputAdornment>
                            <EventIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box>
                <Controller
                  control={control}
                  name="registrationCloseTime"
                  render={props => (
                    <KeyboardTimePicker
                      label="Close time"
                      id="registration-close-time"
                      name="registrationCloseTime"
                      minutesStep={5}
                      mask="__:__ _M"
                      keyboardIcon={<TimeIcon />}
                      value={props.value}
                      innerRef={register}
                      error={!!errors.startTime}
                      helperText={
                        errors.registrationCloseTime
                          ? errors.registrationCloseTime.message
                          : null
                      }
                      onChange={e => handleTimeChange(e, props.onChange)}
                      InputProps={{
                        classes: {
                          adornedEnd: classes.adornedEnd,
                        },
                      }}
                    />
                  )}
                />
              </Box>
            </Grid>
          </Grid>
        </MuiPickersUtilsProvider>
      </Box>
    </Box>
  )
}

export default RegistrationClose
